import { useSetRecoilState } from 'recoil';

import { ShopOrderForSeller } from '@shared/api/shopOrder/shopOrder.interface';
import { Button } from '@shared/components/Button';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { UserRole } from '@shared/types';
import { phoneNumberStringFormator } from '@shared/utils/phoneNumberStringFormator';

import { OrderGuestInfoEditModal } from './OrderGuestInfoEditModal';

interface FlowerOrderInfoSummaryCardProps {
  shopOrder: ShopOrderForSeller;
}

export const ShopOrderDetailInfoCard = function ShopOrderDetailInfoCard({
  shopOrder,
}: FlowerOrderInfoSummaryCardProps) {
  //* 게스트(임시고객) 주문일 때만 구매자 정보 수정 허용 (정회원 계정은 백엔드에서도 403)
  //* roles가 조회 안 된 쿼리에서는 일단 노출 — 백엔드 검증이 최종 보호막
  const guest = shopOrder.user;
  const isGuestOrder =
    typeof guest === 'object' &&
    Boolean(guest?._id) &&
    (guest.roles ? guest.roles.includes(UserRole.StoreGuest) : true);

  const guestEditOpenId = `order-guest-info-edit-${shopOrder._id}`;
  const setGuestEditOpen = useSetRecoilState(simpleOpenAtomFamily(guestEditOpenId));

  return (
    <div className="space-y-2 rounded-md border bg-white px-4 py-2 shadow-sm">
      <div className="flex w-full justify-between gap-4 border-b pb-2">
        <div className="w-1/2 space-y-2">
          <p className="min-w-0 flex-1 text-sm font-bold">받으시는 분</p>
          <div>
            <p className="min-w-0 flex-1 text-sm">
              {shopOrder.deliveryDetail.receiverName}
            </p>
            <p className="text-sm font-medium">
              {phoneNumberStringFormator(shopOrder.deliveryDetail.receiverPhoneNumber)}
            </p>
          </div>
        </div>
        <div className="w-1/2 space-y-2">
          <div className="flex items-center justify-between gap-2">
            <p className="min-w-0 text-sm font-bold">주문자</p>
            {isGuestOrder && (
              <Button
                className="-my-1 h-6 shadow-sm"
                onClick={() => {
                  setGuestEditOpen(true);
                }}
              >
                수정
              </Button>
            )}
          </div>
          <div>
            <p className="min-w-0 flex-1 text-sm">
              {shopOrder.deliveryDetail.senderName}
            </p>
            <a href={`tel:${shopOrder.deliveryDetail.senderPhoneNumber}`}>
              <p className="text-sm font-medium">
                {phoneNumberStringFormator(shopOrder.deliveryDetail.senderPhoneNumber)}
              </p>
            </a>
          </div>
        </div>
      </div>
      <div className="space-y-2">
        <p className="text-sm font-bold">문구정보</p>
        <div className={`flex w-full justify-between gap-4 `}>
          <div className="w-1/2">
            <p className="pb-0.5 text-12 font-medium">보내는분(왼쪽)</p>
            <p className="text-sm">{shopOrder.bugoDetail.senderPhrase}</p>
          </div>
          <div className="w-1/2">
            <p className="pb-0.5 text-12 font-medium">조의문구(오른쪽)</p>
            <p className="text-sm">{shopOrder.bugoDetail.condolencePhrase}</p>
          </div>
        </div>
      </div>
      {isGuestOrder && (
        <OrderGuestInfoEditModal openId={guestEditOpenId} order={shopOrder} />
      )}
    </div>
  );
};
